import { useAccordionAdCpt as useAdCpt } from "@/hooks/adCpt/pageAds";
import { pxChangeVw } from "@/utils";
import { isAlertDetail } from "@/utils/isAlertDetail";
import classNames from "classnames";
import { nanoid } from "nanoid";
import { Fragment } from "react";
import { useClsUtil_01 } from "./useClsUtil_01.tsx";
import { isShowNews1 } from "@/utils/isShowNews1.ts";
import { getCurrentAdScenario } from "@/hooks/useAdScenario.ts";

const Accordion: React.FC<any> = ({
  accordionList,
  setLocalList,
  renderContent,
  renderTitle,
  isEnableScroll,
  expandIndex = 0,
}) => {
  if (!accordionList.length) {
    return null;
  }
  const panelRefs: any[] = [];
  const { pathname } = useLocation();
  const { hostName } = useHostName();
  const { isTranTabAdScenario } = getCurrentAdScenario();
  const _isAlertDetail = isAlertDetail();

  useEffect(() => {
    if (accordionList.length > 0) {
      const newList = [...accordionList];
      newList[expandIndex].isExpand = true;
      const panel = panelRefs[expandIndex].current;
      panel.style.maxHeight = panel.scrollHeight + "px";
      if (_isAlertDetail) {
        panel.style.maxHeight = "none";
      }
      setLocalList(() => newList);
      // 添加滚动到视图的逻辑
      if (isEnableScroll) {
        const timer = setTimeout(() => {
          clearTimeout(timer);
          if (panelRefs[expandIndex]?.current?.parentElement?.parentElement) {
            panelRefs[expandIndex].current.parentElement.parentElement.scrollIntoView({
              behavior: "smooth",
            });
          }
        }, 100);
      }
    }
  }, [accordionList.length, expandIndex]);
  const closeAccordion = () => {
    accordionList.forEach((item: { isExpand: boolean }, index: number) => {
      item.isExpand = false;
      panelRefs[index].current.style.maxHeight = "";
    });
  };
  const handleClick: any = async (item: any, index: number) => {
    const clickItem: any = accordionList.find((object: { id?: string }) => object.id === item.id);
    if (clickItem?.isExpand) {
      closeAccordion();
    } else {
      closeAccordion();
      clickItem.isExpand = true;
      const panel = panelRefs[index].current;
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
    setLocalList(() => [...accordionList]);
  };
  const { getCls01 } = useClsUtil_01();

  return (
    <div className="flex flex-col justify-start gap-y-10">
      {!!accordionList.length &&
        accordionList.map((item: any, index: number) => {
          panelRefs[index] = useRef<any>(null);
          item.id ??= nanoid(16);
          return (
            <Fragment key={index}>
              <div>
                <WeatherContent
                  className={classNames([
                    getCls01({
                      isExpand: item.isExpand,
                      isWarning: item.isWarning,
                    }),
                  ])}
                >
                  <div className="flex flex-col" style={{ rowGap: item.isExpand ? pxChangeVw("10px") : "" }}>
                    {renderTitle && renderTitle({ item, index, handleClick })}
                    <div className="max-h-0 overflow-hidden" ref={panelRefs[index]}>
                      {renderContent && renderContent({ item, index, expandIndex })}
                    </div>
                  </div>
                </WeatherContent>
              </div>
              <div data-position="position-36">
                {((isTranTabAdScenario || [...domainMap["v-ls"]].includes(hostName)) ||
                  isShowNews1().isValidDismoreChannel
                  ? index != 0 && index % 5 === 4
                  : index % 3 == 0) && useAdCpt("position-36", index, accordionList, pathname)}
              </div>
              <div data-position="position-02">
                {index % 3 == 0 && useAdCpt("position-02", index, accordionList, pathname)}
              </div>
            </Fragment>
          );
        })}
    </div>
  );
};
export default Accordion;
